var map = {
	"./add.svg": "76a4",
	"./atmosphere.svg": "4d6a",
	"./clock.svg": "755b",
	"./contacter.svg": "2ad7",
	"./crown-icon.svg": "6922",
	"./dots_v.svg": "bdd1",
	"./edit.svg": "daf0",
	"./facebook.svg": "8485",
	"./filter-icon.svg": "1cce",
	"./fire.svg": "62e5",
	"./glass.svg": "0aed",
	"./image.svg": "931c",
	"./menu.svg": "d17f",
	"./music.svg": "65ad",
	"./onlyTopTeamRegistrationIcon.svg": "da0a",
	"./pie.svg": "06ff",
	"./question_feedback_disable_icon.svg": "ab19",
	"./question_feedback_icon.svg": "48d8",
	"./search-icon.svg": "7669",
	"./search_franchise.svg": "c5ec",
	"./table.svg": "979b",
	"./text.svg": "d36f",
	"./trophy.svg": "e6bc",
	"./user.svg": "6aed",
	"./video.svg": "512b",
	"./vkontakte.svg": "5699",
	"./Без ранга.svg": "99d9",
	"./Бриллиантовая федерация.svg": "3c16",
	"./Бронзовое братство.svg": "bac8",
	"./Властелины музыки.svg": "5767",
	"./Железная банда.svg": "b3b2",
	"./Золотой альянс.svg": "dfc9",
	"./Каменная стая.svg": "127f",
	"./Короли чартов.svg": "15e9",
	"./Кумиры поколений.svg": "44b7",
	"./Мастера Караоке.svg": "dc7d",
	"./Певцы в душе.svg": "967f",
	"./Провинциальные звездочки.svg": "4d88",
	"./Серебряный клан.svg": "d5e7",
	"./Хитмейкеры.svg": "4b50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";